import { Paragraph } from '@eggplant/pattern-library'

const SpaceEnvironmentsEdit = () =>
  <Paragraph>
    <strong>
      All environments are available in the shared space by default. Select the spaces you want to give access to.
    </strong>
  </Paragraph>

export default SpaceEnvironmentsEdit
